// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__slHRs","col":"CardReaderDesc_col__1x2xW","label":"CardReaderDesc_label__3v1UL"};